import React from "react";

import TablaSettings from "./components/TablaSettings";

const HualpenPage = () => {
  return (
    <div className="container-fluid">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <div className="page-pretitle">Sistema Carga Masiva</div>
              <h2 className="page-title">Hualpen</h2>
            </div>
          </div>
          <div className="pt-3">
            <div className="card">
              <div className="card-body">
                <TablaSettings />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HualpenPage;
